<template>
  <li
      v-if="isFolder || !(hiddenSearchMiss && searchText && model.isSearchMatch === false)"
      role="treeitem"
      :id="'treeitem_' + menuTag"
      :class="classes"
      :draggable="isDraggable"
      style="margin-left: 6px;position: relative"
      @mouseover.stop="events.mouseover"
      @mouseout.stop="events.mouseout"
      @contextmenu="$ContextMenu($event,$root,menuTag)"
      @dragstart.stop="onItemDragStart($event, _self, _self.model)"
      @dragend.stop.prevent="onItemDragEnd($event, _self, _self.model)"
      @dragover.stop.prevent="isDragEnter = true"
      @dragenter.stop.prevent="isDragEnter = true"
      @dragleave.stop.prevent="isDragEnter = false"
      @drop.stop.prevent="handleItemDrop($event, _self, _self.model)">
    <div class="tree-item-content-wrapper">
      <div role="presentation" :class="wholeRowClasses" v-if="isWholeRow">&nbsp;</div>
      <i v-if="isFolder && showExpandIcon" class="iconfont icon-fold-color" :class="treeExpandIconClass" role="presentation" @click="handleItemToggle"></i>
      <i v-if="showEmptyExpand && !(isFolder && showExpandIcon)" class="iconfont icon-fold-color icon-empty" role="presentation"></i>
      <div :class="anchorClasses">
        <i class="tree-icon tree-checkbox" role="presentation" v-if="showCheckbox && !model.loading"></i>
        <div class="tree-show-info" v-on="{click: handleItemClick, dblclick: handleItemDblClick}">
          <slot :vm="this" :model="model">
            <i  :class="themeIconClasses" role="presentation" v-if="!model.loading"></i>
            <span v-html="model[textFieldName]"></span>
          </slot>
        </div>
        <div class="tree-item-info" v-if="showInfoIcon" :class="treeItemInfoClass" :style="infoStyle">
          <i :title="infoIconHoverTitle" class="iconfont icon-xinxi" @click="handleItemInfoClick"></i>
        </div>
      </div>
      <ul role="group" ref="group" class="tree-children" v-if="isFolder && isExpanded" :style="groupStyle">
        <tree-item  v-for="(child) in model[childrenFieldName]"
                    :key="child[nodeIdentifyFieldName]"
                    :itemMenuData="child"
                    :hiddenSearchMiss="hiddenSearchMiss"
                    :searchText="searchText"
                    :cacheScope="cacheScope"
                    :cacheEnable="cacheEnable"
                    :childTreeItemMarginLeft="childTreeItemMarginLeft"
                    :showRightInfoIcon="showRightInfoIcon"
                    :showExpandIcon="showExpandIcon"
                    :activeNodeItemIdentify="activeNodeItemIdentify"
                    :showNodeTypeIcon="showNodeTypeIcon"
                    :showEmptyExpand="showEmptyExpand"
                    :supportNodeTypes="supportNodeTypes"
                    :parentFieldName="parentFieldName"
                    :menuTag="child[nodeIdentifyFieldName]"
                    :contextMenu="contextMenu"
                    :cacheOpenTreeItems="cacheOpenTreeItems"
                    :menuList="child.menuList ? child.menuList: []"
                    :text-field-name="textFieldName"
                    :value-field-name="valueFieldName"
                    :children-field-name="childrenFieldName"
                    :item-events="itemEvents"
                    :whole-row="wholeRow"
                    :show-checkbox="showCheckbox"
                    :allow-transition="allowTransition"
                    :height= "height"
                    :parent-item="model[childrenFieldName]"
                    :parent="model"
                    :draggable="draggable"
                    :drag-over-background-color="dragOverBackgroundColor"
                    :onItemDblclick="onItemDblclick"
                    :on-item-click="onItemClick"
                    :on-item-drag-start="onItemDragStart"
                    :on-item-drag-end="onItemDragEnd"
                    :on-item-drop="onItemDrop"
                    :onItemInfoClickCallback="onItemInfoClickCallback"
                    @item-toggle="onItemToggle($event)"
                    @context-menu-click="onContextMenuClick($event)"
        >
          <template slot-scope="_">
            <slot :vm="_.vm" :model="_.model">
              <i :class="_.vm.themeIconClasses"
                 role="presentation" v-if="!model.loading"></i>
              <span v-html="_.model[textFieldName]"></span>
            </slot>
          </template>
        </tree-item>
      </ul>
      <div v-if="contextMenu">
        <context-menu :tag="menuTag" :list="menuList ? menuList: []"
                      :underline="contextMenuOption.underline"
                      :userCustomerIcon="contextMenuOption.userCustomerIcon"
                      :arrow="contextMenuOption.arrow"
                      @context-menu-click="onContextMenuClick($event, menuTag)"
        >
        </context-menu>
      </div>
    </div>
  </li>
  <!--</div>-->
</template>
<script>
import ContextMenu from './../context-menu/index'
import { setOpenTreeItem } from '../lib/localStorage'
export default {
  name: 'TreeItem',
  components: { ContextMenu },
  props: {
    /**
     * 悬浮i图标显示的详情
     */
    infoIconHoverTitle: {
      type: String,
      default: '显示详情'
    },
    /**
     * 缓存数据的scope,标识只有该scope下面的数据有效，例如不同用户传入不用的用户名用来区分各自的缓存数据
     */
    cacheScope: { type: String, default: 'default' },
    /*
   是否开启缓存，开启缓存后会记录节点的展开状态
   */
    cacheEnable: { type: Boolean, default: false },
    /*
    被缓存的展开的数据项
    */
    cacheOpenTreeItems: { type: Array },
    /*
    激活的节点标识
    */
    activeNodeItemIdentify: {
      type: [String, Number],
      default: -1
    },
    hiddenSearchMiss: {
      type: Boolean,
      default: false
    },
    searchText: { type: String, default: '' },
    /** 子树与父级包裹的左侧间距 **/
    childTreeItemMarginLeft: {
      type: Number,
      default: 15
    },
    showNodeTypeIcon: {
      type: Boolean,
      default: true
    },
    showEmptyExpand: { type: Boolean, default: false },
    showExpandIcon: { type: Boolean, default: true },
    showRightInfoIcon: { type: Boolean, default: false },
    itemMenuData: { type: Object, required: true },
    contextMenu: { type: Boolean, default: false },
    supportNodeTypes: { type: Array, default: () => [] },
    contextMenuOption: {
      type: Object,
      default () {
        return {
          underline: true,
          arrow: true,
          userCustomerIcon: false
        }
      }
    },
    /*
   父节点字段名，通过当前节点该字段名可以获取父节点的引用
   */
    parentFieldName: { type: String, default: 'parent' },
    nodeIdentifyFieldName: { type: String, default: 'menuTag' },
    /*
    节点唯一标识
    */
    menuTag: { type: [String, Number], default: '1' },
    menuList: { type: Array, default () { return [] } },
    textFieldName: { type: String },
    valueFieldName: { type: String },
    childrenFieldName: { type: String },
    itemEvents: { type: Object },
    wholeRow: { type: Boolean, default: false },
    showCheckbox: { type: Boolean, default: false },
    allowTransition: { type: Boolean, default: true },
    height: { type: Number, default: 24 },
    parent: { type: Object },
    parentItem: { type: Array },
    draggable: { type: Boolean, default: false },
    dragOverBackgroundColor: { type: String },
    onItemClick: {
      type: Function, default: () => false
    },
    onItemDblclick: {
      type: Function, default: () => false
    },
    onItemInfoClickCallback: {
      type: Function, default: () => false
    },
    onItemDragStart: {
      type: Function, default: () => false
    },
    onItemDragEnd: {
      type: Function, default: () => false
    },
    onItemDrop: {
      type: Function, default: () => false
    },
    klass: String
  },
  data () {
    return {
      isHover: false,
      isDragEnter: false,
      model: this.itemMenuData,
      isExpanded: false,
      maxHeight: 0,
      events: {},
      isSearchMatch: false
    }
  },
  watch: {
    model () {
      this.initTreeNode()
    },
    isDragEnter (newValue) {
      if (newValue) {
        this.$el.style.backgroundColor = this.dragOverBackgroundColor
      } else {
        this.$el.style.backgroundColor = 'inherit'
      }
    },
    itemMenuData (newValue) {
      this.model = newValue
      if (!this.model.hasOwnProperty('nodeType')) {
        if (this.model.hasOwnProperty('children') && this.model.children.length > 0) {
          this.model.nodeType = 'folder'
        } else {
          this.model.nodeType = 'file'
        }
      }
      if (!this.model.hasOwnProperty('opened')) {
        this.$set(this.model, 'opened', false)
      }
      if (!this.model.hasOwnProperty('icon') || this.model.icon === '') {
        let findNodeType = this.getSupportNodeType()
        if (findNodeType) {
          this.model.icon = findNodeType.iconClass
        }
      }
    },
    'model.opened': {
      handler: function (val, oldVal) {
        this.handleGroupMaxHeight()
        this.isExpanded = val
      },
      immediate: true
    },
    'itemMenuData.isSearchMatch': {
      handler: function (val, oldVal) {
        this.isSearchMatch = val
      },
      immediate: true
    },
    'itemMenuData.isSelected': {
      handler: function (val) {
        if (val) {
          this.$nextTick(() => {
            let scrollItem = document.getElementById('treeitem_' + this.activeNodeItemIdentify)
            if (scrollItem) {
              scrollItem.scrollIntoViewIfNeeded(true)
            }
          })
        }
      },
      immediate: true
    },
    isExpanded (val) {
      // if (val) {
      //   if (this.cacheEnable) {
      //     this.addTreeOpenCacheRecord()
      //   }
      // } else {
      //   if (this.cacheEnable) {
      //     this.removeTreeOpenCacheRecord()
      //   }
      // }
    }
  },
  computed: {
    isSelected () {
      return (this.activeNodeItemIdentify + '') === (this.model[this.nodeIdentifyFieldName] + '')
    },
    showInfoIcon () {
      if (this.model.hasOwnProperty('showInfoIcon')) {
        return this.model.showInfoIcon
      } else {
        return this.showRightInfoIcon
      }
    },
    isEmptyFolder () {
      return this.model.nodeType === 'folder' && (!this.model[this.childrenFieldName] || this.model[this.childrenFieldName].length === 0)
    },
    isFolder () {
      return this.model[this.childrenFieldName] && this.model[this.childrenFieldName].length
      // if (this.model.nodeType) {
      //   return this.model.nodeType === 'folder'
      // } else {
      // }
    },
    treeExpandIconClass () {
      return [
        { 'icon-shouqi': !this.model.opened },
        { 'icon-zhankai': this.model.opened }
      ]
    },
    infoStyle () {
      return { opacity: this.isHover ? 1 : 0 }
    },
    treeItemInfoClass () {
      return [
        { 'tree-item-info-display': this.isHover }
      ]
    },
    classes () {
      return [
        { 'tree-node': true },
        { 'tree-open': this.model.opened },
        { 'tree-closed': !this.model.opened },
        { 'tree-leaf': !this.isFolder },
        { 'tree-loading': !!this.model.loading },
        { 'tree-drag-enter': this.isDragEnter },
        { [this.klass]: !!this.klass }
      ]
    },
    anchorClasses () {
      return [
        { 'tree-anchor': true },
        { 'tree-disabled': this.model.disabled },
        { 'tree-selected': this.model && this.model.nodeType !== 'folder' && this.isSelected },
        { 'tree-hovered': this.isHover },
        { 'tree-search-matched': this.isSearchMatch }
      ]
    },
    wholeRowClasses () {
      return [
        { 'tree-wholerow': true },
        { 'tree-wholerow-clicked': this.model.selected }
        // { 'tree-wholerow-hovered': this.isHover }
      ]
    },
    themeIconClasses () {
      return [
        { 'tree-icon': true },
        { 'tree-themeicon': true },
        { [this.model.icon]: !!this.model.icon },
        { 'tree-themeicon-custom': !!this.model.icon }
      ]
    },
    isWholeRow () {
      if (this.wholeRow) {
        if (this.$parent.model === undefined) {
          return true
        } else if (this.$parent.model.opened === true) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    groupStyle () {
      return {
        // 'position': this.model.opened ? '' : 'relative',
        // 'max-height': this.allowTransition ? this.maxHeight + 'px' : '',
        // 'transition-duration': this.allowTransition ? Math.ceil(this.model[this.childrenFieldName].length / 100) * 300 + 'ms' : '',
        // 'transition-property': this.allowTransition ? 'max-height' : '',
        // 'display': this.model.opened ? 'block' : 'none',
        'margin-left': this.childTreeItemMarginLeft + 'px'
        // 'display': this.allowTransition ? 'block' : (this.model.opened ? 'block' : 'none')
      }
    },
    /**
     * 如果子节点有draggable 属性，则使用子节点属性，否则使用全局配置
     * @return {*}
     */
    isDraggable () {
      if (!this.itemMenuData) {
        return this.draggable
      }
      if (this.itemMenuData.hasOwnProperty('draggable')) {
        return this.itemMenuData.draggable
      } else {
        return this.draggable
      }
    }
  },
  methods: {
    initTreeNode () {
      this.handleGroupMaxHeight()
      if (this.cacheEnable && this.hasOpenedBefore()) {
        this.model.opened = true
        this.isExpanded = true
      } else {
        this.isExpanded = this.model.opened
      }
    },
    shouldOpenItem () {
      return this.checkHasMatchChild(this.itemMenuData)
    },
    checkHasMatchChild (itemMenu) {
      let matchResult = false
      if (itemMenu.nodeType === 'folder' && itemMenu.hasOwnProperty('children') && itemMenu.children.length > 0) {
        for (let i = 0; i < itemMenu.children.length; i++) {
          matchResult = this.checkHasMatchChild(itemMenu.children[i])
          if (matchResult) {
            break
          }
        }
      } else {
        if (itemMenu[this.textFieldName].indexOf(this.searchText) !== -1) {
          matchResult = true
        }
      }
      return matchResult
    },
    getSupportNodeType () {
      if (this.model.hasOwnProperty('nodeType')) {
        let types = this.supportNodeTypes.filter((item) => item.nodeType === this.model.nodeType)
        if (types && types.length > 0) {
          return types[0]
        } else {
          return false
        }
      } else {
        return false
      }
    },
    handleItemInfoClick () {
      this.onItemInfoClickCallback(this.model)
    },
    handleItemToggle () {
      if (this.isFolder) {
        this.isExpanded = !this.isExpanded
        this.$emit('item-toggle', this.model)
      }
    },
    onItemToggle ($event) {
      this.$emit('item-toggle', $event)
    },
    handleGroupMaxHeight () {
      if (this.allowTransition) {
        let length = 0
        let childHeight = 0
        if (this.model.opened) {
          length = this.$children.length
          for (let children of this.$children) {
            if (children.maxHeight) {
              childHeight += children.maxHeight
            }
          }
        }
        this.maxHeight = length * this.height + childHeight
        if (this.$parent.$options._componentTag === 'tree-item') {
          this.$parent.handleGroupMaxHeight()
        }
      }
    },
    handleItemClick (e) {
      if (this.model.disabled) return
      if ((this.activeNodeItemIdentify + '') === (this.model[this.nodeIdentifyFieldName] + '')) {
        this.model.selected = true
      } else {
        this.model.selected = false
      }
      if (this.isFolder) {
        this.$emit('item-toggle', this.model)
      } else {
        this.onItemClick(this, this.model, e)
      }
    },
    handleItemDblClick (e) {
      if (this.model.disabled) return
      if ((this.activeNodeItemIdentify + '') === (this.model[this.nodeIdentifyFieldName] + '')) {
        this.model.selected = true
      } else {
        this.model.selected = false
      }
      // this.model.selected = !this.model.selected
      this.onItemDblclick(this, this.model, e)
      if (this.isFolder) {
        this.isExpanded = this.model.opened
      }
    },
    handleItemMouseOver () {
      this.isHover = true
    },
    handleItemMouseOut () {
      this.isHover = false
    },
    handleItemDrop (e, oriNode, oriItem) {
      this.$el.style.backgroundColor = 'inherit'
      this.onItemDrop(e, oriNode, oriItem)
    },
    onContextMenuClick (menuItem, menuTag) {
      if (menuItem && menuItem.hasOwnProperty('treeItem')) {
        this.$emit('context-menu-click', menuItem)
      } else {
        this.$emit('context-menu-click', { menuItem, treeItem: this.itemMenuData, menuTag })
      }
    },
    addTreeOpenCacheRecord () {
      let nodeIndex = this.getTreeIndexFromNodeOpenedItems()
      if (nodeIndex === -1) {
        this.cacheOpenTreeItems.push(this.model[this.nodeIdentifyFieldName])
        setOpenTreeItem(this.cacheScope, this.cacheOpenTreeItems)
      }
    },
    removeTreeOpenCacheRecord () {
      let deleteNodeIndex = this.getTreeIndexFromNodeOpenedItems()
      if (deleteNodeIndex !== -1) {
        this.cacheOpenTreeItems.splice(deleteNodeIndex, 1)
        setOpenTreeItem(this.cacheScope, this.cacheOpenTreeItems)
      }
    },
    getTreeIndexFromNodeOpenedItems () {
      return this.cacheOpenTreeItems.findIndex(item => (item + '') === (this.model[this.nodeIdentifyFieldName] + ''))
    },
    hasOpenedBefore () {
      return this.getTreeIndexFromNodeOpenedItems() !== -1
    },
    scrollToActiveNoteItem () {
      setTimeout(() => {
        let scrollItem = document.getElementById('treeitem_' + this.activeNodeItemIdentify)
        if (scrollItem) {
          scrollItem.scrollIntoViewIfNeeded(true)
        }
      }, 100)
    }
  },
  created () {
    const self = this
    const events = {
      'mouseover': this.handleItemMouseOver,
      'mouseout': this.handleItemMouseOut
    }
    for (let itemEvent in this.itemEvents) {
      let itemEventCallback = this.itemEvents[itemEvent]
      if (events.hasOwnProperty(itemEvent)) {
        let eventCallback = events[itemEvent]
        events[itemEvent] = function (event) {
          eventCallback(self, self.model, event)
          itemEventCallback(self, self.model, event)
        }
      } else {
        events[itemEvent] = function (event) {
          itemEventCallback(self, self.model, event)
        }
      }
    }
    this.events = events
    if (!self.model.hasOwnProperty('nodeType')) {
      if (self.model.hasOwnProperty('children') && self.model.children.length > 0) {
        self.model.nodeType = 'folder'
      } else {
        self.model.nodeType = 'file'
      }
    }
    if (!self.model.hasOwnProperty('icon') || self.model.icon === '') {
      let findNodeType = self.getSupportNodeType()
      if (findNodeType) {
        self.model.icon = findNodeType.iconClass
      }
    }
  },
  mounted () {
    // this.initTreeNode()
  }
}
</script>
<style scoped>
</style>
